// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__Lsg+D","modal":"Modal_modal__+zPST","slide-down":"Modal_slide-down__dLn8R"};